import apiClient from './apiClient'


const getUserState = (tenant) => {
  return apiClient.get(`/${tenant}/UserState`)
}

const setUserState = (tenant, userState) => {
  return apiClient.put(`/${tenant}/UserState`, userState)
}


export default {
  getUserState,
  setUserState
}
